import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/material/form-field';

@Component({
  selector: 'app-formly-button-type',
  template: `
  <div>
    <button [type]="to.type" [ngClass]="'btn btn-' + to.btnType" (click)="onClick($event)">
      {{ to.text }}
      <i class="{{to.icon.fontSet}} {{to.icon.fontIcon}}" *ngIf="to.icon"></i>
    </button>
  </div>
      `,
    
})
// <i class="{{ to.icon.fontSet + to.icon.fontIcon }}"></i>
export class ButtonTypeComponent extends FieldType implements OnInit {
  /**
   * Class constructor
   */
  constructor(
  ) {
    super();
  }

  /**
   * Init component
   *
   * @since 1.0.0
   */
  ngOnInit(): void {
  }

  onClick($event: any) {
    if (this.to.onClick) {
      this.to.onClick($event);
    }
  }
}